
export class ScanPassResponseDto {
  passName: string;
  userInfo: string;
  validUntil: Date;
  passUsageCount: number;
  passScannedCount: number;
}
